enum ApplicableYearEnum {
  FROM_17_TO_18 = 'from17To18',
  FROM_18_TO_19 = 'from18To19',
  FROM_19_TO_20 = 'from19To20',
  FROM_20_TO_21 = 'from20To21',
  FROM_21_TO_22 = 'from21To22',
}
export default ApplicableYearEnum;
export { ApplicableYearEnum };
